module.exports = __webpack_public_path__ + "img/登录页面艾德logo.8f154694.png";